import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

/** Selected-attorney summary card shared by historic, principal, and retrieval surfaces. */
export default function SelectedAttorneyInfoCard({
  title,
  attorney,
  officeAddressLabel = "Office Address",
}) {
  if (!attorney) return null;

  return (
    <Box
      sx={{
        mt: 2,
        mb: 3,
        p: 2,
        border: "1px solid #e0e0e0",
        borderRadius: 2,
        backgroundColor: "#f9f9f9",
        boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
        {title}
      </Typography>
      <Typography variant="body1">
        <strong>Name:</strong> {attorney.label}
      </Typography>
      <Typography variant="body1">
        <strong>Position:</strong> {attorney.position}
      </Typography>
      <Typography variant="body1">
        <strong>{officeAddressLabel}:</strong> {attorney.address}
      </Typography>
      <Typography variant="body1">
        <strong>City/State/Zip:</strong> {attorney.city}, {attorney.state}{" "}
        {attorney.zip_code}
      </Typography>
    </Box>
  );
}

SelectedAttorneyInfoCard.propTypes = {
  title: PropTypes.string.isRequired,
  attorney: PropTypes.object,
  officeAddressLabel: PropTypes.string,
};
